import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import LiveFeed from "./components/LiveFeed";
import CategoryGrid from "./components/CategoryGrid";
import FeaturedStories from "./components/FeaturedStories";
import Discussion from "./components/Discussion";
import About from "./components/About";
import FaqSection from "./components/FaqSection";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <HotRank />
        <LiveFeed />
        <CategoryGrid />
        <FeaturedStories />
        <Discussion />
        <About />
        <FaqSection />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}